import { useState, useEffect, useMemo } from 'react';
import en from '../../lang/en-us';
import { Grid } from '@material-ui/core';
import SearchInput from '../../lib/SearchInput';
import { getCRMDetails, getAmcList } from '../../redux-store/actions/nct';
import { connect } from 'react-redux';
import { IconButton } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { useTableWithCollapse } from '../../lib/DataTable/customHooks';
import { TableWithCollapse } from '../../lib/DataTable';
import { TableColumn } from '../../lib/DataTable/types';
import NoFoliosFound from './makeNct/NoFoliosFound';
import { CombinedState } from 'redux';
import { RootStateType } from '../../redux-store/reducers';
import { getDate } from '../../utils/constants';

const { crmDashboard } = en;

const columns: TableColumn[] = [
    {
        field: 'id',
        headerName: 'S No.',
        valueGetter: ({ index = 0 }) =>
            (index + 1).toLocaleString('en-US', {
                minimumIntegerDigits: 2,
                useGrouping: false,
            }),
    },
    { field: 'amcName', headerName: 'FUND NAME' },
    { field: 'pan', headerName: 'PAN/PEKRN' },
    { field: 'folio', headerName: 'FOLIO/DPID' },
    { field: 'refNumber', headerName: 'REF.NUMBER' },
    { field: 'receivedDate', headerName: 'RECEIVED DATE' },
    { field: 'requestSource', headerName: 'REQUEST SOURCE' },
    { field: 'responseDate', headerName: 'RESPONSE DATE' },
    {
        field: 'currentStatus',
        headerName: 'STATUS',
        renderCell: ({ row }) => {
            return (
                <div
                    className={`status-text ${row?.currentStatus === 'Pending'
                        ? 'status-pending'
                        : row?.currentStatus === 'Completed'
                            ? 'status-completed'
                            : row?.currentStatus === 'Inprogress'
                                ? 'status-inprogress'
                                : 'status-background'
                        }`}
                >
                    {row?.currentStatus}
                </div>
            );
        },
    },
    {
        field: '',
        headerName: '',
        renderCell: ({ setCollapse, collapse }) => {
            return (
                <IconButton
                    aria-label="expand row"
                    size="small"
                    onClick={(e) => {
                        e.stopPropagation();
                        setCollapse(!collapse);
                    }}
                >
                    {collapse ? (
                        <>
                            <span>Hide</span>
                            <KeyboardArrowUpIcon />
                        </>
                    ) : (
                        <>
                            <span>View</span>
                            <KeyboardArrowDownIcon />
                        </>
                    )}
                </IconButton>
            );
        },
    },
    // {
    //     isFilter: true,
    //     field: 'assetType',
    //     headerName: 'Category',
    //     filterBy: true,
    //     renderStaticFilters: [EQUITY, LIQUID, DEBT, OTHER],
    // },
];

function CRMDashboard(props: any) {
    const [activeClass, setClass] = useState<boolean>(false);
    const [sortBy, setSortBy] = useState<any>('NONE');
    const [searchText, setText] = useState<string>('');
    const [summary, setSummary] = useState<any>({});
    const [dataArr, setDataArray] = useState<any>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const filteredData = useMemo(() => {
        if (searchText) {
            return dataArr.filter((_ele: any) => {
                return (_ele?.amcName || '').toLocaleLowerCase().includes(searchText.toLowerCase());
            });
        }
        return dataArr;
    }, [searchText, dataArr]);
    const { tableRows, tableColumns } = useTableWithCollapse<any>({
        // rows: dataArr,
        rows: filteredData,
        columns,
        loading,
    });

    useEffect(() => {
        async function crm_data() {
            setLoading(true);
            const { pan = '', pekrn = '', mobile = '', reqId = '' } = props;
            try {
                let { body = {} } =
                    (await props.getCRMDetails({
                        pan,
                        pekrn,
                        mobile,
                        reqId,
                    })) || {};
                const { summary = {}, data = [] } = body;
                setLoading(false);
                setSummary(summary);
                setDataArray(data);
            } catch (err: any) {
                alert(err.message);
            } finally {
                setLoading(false);
            }
        }
        crm_data();
    }, []);

    const _renderCollapse = ({ row }: { row: any }) => {
        return (
            <div className="crm-table-collapse">
                <div className="crm-table-collapse-info">
                    <h5>Scheme Name</h5>
                    <p>{row.scheme}</p>
                </div>
                <div className="crm-table-collapse-info">
                    <h5>Request Mode</h5>
                    <p>{row.requestMode}</p>
                </div>
                <div className="crm-table-collapse-info">
                    <h5>Nature of Complaint</h5>
                    <p>
                        {row.natureOfComplaint === 'F'
                            ? crmDashboard.financial
                            : crmDashboard.nonFinancial}
                    </p>
                </div>
                <div className="crm-table-collapse-info">
                    <h5>Issue Category</h5>
                    <p>{row.issueCategory || '---'}</p>
                </div>
                <div className="crm-table-collapse-info">
                    <h5>Resolution Response</h5>
                    <p>{row.resolutionResponse || '---'}</p>
                </div>
                {/* <div className="crm-table-collapse-info description">
                    <h5>Issue Description</h5>
                    <p>{row.issueDescription || '---'}</p>
                </div> */}
            </div>
        );
    };

    return (
        <div className="curved-bg">
            <div className="crm-dashboard">
                <div className="maxWidth">
                    <div className="crm-content">
                        <h2 className="heading">{crmDashboard.heading}</h2>
                        <div className="crm-top-cards">
                            <Grid container spacing={2}>
                                <Grid item xs={6} md={3}>
                                    <div className="crm-top-info">
                                        <h4>{summary?.totalRequest || 0}</h4>
                                        <p>{crmDashboard.totalRequests}</p>
                                    </div>
                                </Grid>
                                <Grid item xs={6} md={3}>
                                    <div className="crm-top-info">
                                        <h4>{summary?.rejected || 0}</h4>
                                        <p>{crmDashboard.rejectedRequests}</p>
                                    </div>
                                </Grid>
                                <Grid item xs={6} md={3}>
                                    <div className="crm-top-info">
                                        <h4>{summary?.pending || 0}</h4>
                                        <p>{crmDashboard.inProgressRequests}</p>
                                    </div>
                                </Grid>
                                <Grid item xs={6} md={3}>
                                    <div className="crm-top-info">
                                        <h4>{summary?.resolved || 0}</h4>
                                        <p>{crmDashboard.resolvedRequests}</p>
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                        <div className="crm-table">
                            <div className="portfolio-details">
                                <div className="portfolio-details-amc">
                                    <div className="portfolio-details-filter">
                                        <SearchInput
                                            onChange={(e: any) => setText(e.target.value)}
                                            value={searchText}
                                            id="search-amc"
                                            placeholder="Search Fund House"
                                            darkmode={true}
                                        />
                                        <div
                                            role="status"
                                            aria-live="polite"
                                            aria-atomic="true"
                                            style={{
                                                position: 'absolute',
                                                left: '-10000px',
                                                width: '1px',
                                                height: '1px',
                                                overflow: 'hidden'
                                            }}
                                        >
                                            {filteredData.length} {filteredData.length === 1 ? 'result' : 'results'} found
                                        </div>
                                        {/* <div className="portfolio-details-sortby">
                                            <p>{dashboard.portfolioDetails.sortby} :</p>
                                            <FormControl variant="filled">
                                                <Select
                                                    labelId="portfolio-sortby-label"
                                                    id="portfolio-sortby"
                                                    onChange={({ target: { value } }) =>
                                                        setSortBy(value)
                                                    }
                                                    value={sortBy}
                                                >
                                                    <MenuItem value="NONE">
                                                        {dashboard.portfolioDetails.select}
                                                    </MenuItem>
                                                    {SORT_TYPES.map(
                                                        (type: string, index: number) => (
                                                            <MenuItem key={index} value={index}>
                                                                {type}
                                                            </MenuItem>
                                                        ),
                                                    )}
                                                </Select>
                                            </FormControl>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                            {useMemo(
                                () =>
                                    tableRows.length || loading ? (
                                        <TableWithCollapse
                                            columns={tableColumns}
                                            rows={tableRows.sort((a, b) => {
                                                if (getDate(a.receivedDate) > getDate(b.receivedDate)) {
                                                    return -1;
                                                }
                                                else if (getDate(a.receivedDate) < getDate(b.receivedDate)) {
                                                    return 1;
                                                }
                                                return 0;
                                            })}
                                            renderCollapse={_renderCollapse}
                                        />
                                    ) : (
                                        <NoFoliosFound info={en.common.noRecordsFound} />
                                    ),
                                [tableRows],
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default connect(
    ({ authReducer, portfolio }: CombinedState<RootStateType>) => ({
        ...portfolio,
        ...authReducer,
    }),
    { getCRMDetails, getAmcList },
)(CRMDashboard);
